import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { DefaultButton } from "../../../Buttons";
import { withStyles } from "@material-ui/core/styles";
import * as bidClassesActions from "./../../../../data/bidClasses/actions";
import * as openTimeSearchActions from "../../../../data/openTimeSearch/actions";
import { RESERVE_BID_SCOPE } from "../../../../data/constants";
import { useSessionStorageListener } from "../../helpers";
import { getLastBidScopeUsedString } from "../../../../scenes/BidSession/helpers";
import { useLanguage } from "../../../../context/LanguageContext";

const AddButton = withStyles({
  root: {
    color: "#009688 !important",
    backgroundColor: "#d2e6e4 !important",
    fontWeight: "bold !important",
    fontSize: "12px !important",
    "&:disabled": {
      opacity: "0.5",
      cursor: "none",
    },
  },
})(DefaultButton);

const AddRequest = (props) => {
  const { labels } = useLanguage();
  const ADDING_BID = labels.ADDING_BID || {};
  const [isSaving, setIsSaving] = useState(false);
  const [isDisabled, setIsDisabled] = useState(
    getLastBidScopeUsedString() === RESERVE_BID_SCOPE
  );

  // Use the helper to listen for sessionStorage changes
  useSessionStorageListener(() => {
    const currentScope = getLastBidScopeUsedString();
    setIsDisabled(currentScope === RESERVE_BID_SCOPE);
  });

  const handleRequest = () => {
    if (isSaving) return;
    setIsSaving(true);

    const { setFromAddButton } = props;
    setFromAddButton(true);

    const {
      handleActionPreference,
      showNotification,
      requestPreferencePayload,
      addRequestFailure,
      addRequestSuccess,
      bidSession,
    } = props;

    const { preferenceOptionId, wish, parameterValues } =
      requestPreferencePayload;
    const editPreference = {};

    bidClassesActions.default
      .savePreference(
        bidSession,
        preferenceOptionId,
        parameterValues,
        editPreference,
        wish
      )()
      .then((response) => {
        addRequestSuccess();
        setIsSaving(false);
        showNotification(ADDING_BID.ADD_MESSAGE);
        handleActionPreference(response, true);
      })
      .catch((e) => {
        addRequestFailure();
        setIsSaving(false);
        showNotification(e.response.data.message);
        handleActionPreference(e.response, false);
      });
  };

  return (
    <div className="add-button">
      <AddButton disabled={isDisabled} onClick={() => handleRequest()}>
        {props.label}
      </AddButton>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  addRequestSuccess: () =>
    dispatch(openTimeSearchActions.dispatchAddOpenTimeRequestSuccess()),
  addRequestFailure: () =>
    dispatch(openTimeSearchActions.dispatchAddOpenTimeRequestFailure()),
});

AddRequest.propTypes = {
  handleActionPreference: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  bidmode: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  requestPreferencePayload: PropTypes.object.isRequired,
  addRequestSuccess: PropTypes.func.isRequired,
  addRequestFailure: PropTypes.func.isRequired,
  bidSession: PropTypes.object.isRequired,
};

export default connect(null, mapDispatchToProps)(AddRequest);
